'use client'

import { InView } from 'react-intersection-observer'
import { Cell, Text, Image, Spacer } from '@vinted/web-ui'

import { LayoutElementModel, ThumbnailsBlockStyle } from '@marketplace-web/domain/home-page-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import HomepageBlockLayout from '../HomepageBlockLayout'
import ScrollableContentBody from '../ScrollableContentBody'
import useLayoutsTracking from '../hooks/useLayoutsTracking'

type Props = {
  elements: Array<LayoutElementModel>
  title: string
  name: string
  position: number
  homepageSessionId: string
  id: string
  style: ThumbnailsBlockStyle
  subtitle: string | null
}

const IconThumbnails = (props: Props) => {
  const { handleItemClick, handleItemView } = useLayoutsTracking(props)
  const breakpoints = useBreakpoint()

  const renderThumbnail = (thumbnail: LayoutElementModel, index: number) => (
    <InView
      as="article"
      key={index}
      onChange={handleItemView(thumbnail, index)}
      className="single-thumbnail-container single-thumbnail-container--icon"
    >
      <Cell
        styling={Cell.Styling.Tight}
        clickable
        url={thumbnail.cta.url}
        onClick={handleItemClick(thumbnail, index)}
        testId="homepage-layouts-thumbnail"
        aria={{ 'aria-label': thumbnail.cta.accessibilityLabel || '' }}
        body={
          <div className="single-thumbnail-container-body">
            <div className="thumbnail-image--icon">
              <Image
                src={thumbnail.photo.url}
                scaling={Image.Scaling.Cover}
                size={Image.Size.Regular}
              />
            </div>
            <Spacer />
            <div className="thumbnail-title-wrapper homepage-layouts-text-truncation">
              <Text
                width={Text.Width.Parent}
                type={breakpoints.desktops ? Text.Type.Subtitle : Text.Type.Caption}
                text={thumbnail.title}
                alignment={Text.Alignment.Center}
                theme="amplified"
                as="h3"
              />
            </div>
          </div>
        }
      />
    </InView>
  )

  return (
    <HomepageBlockLayout
      {...props}
      headerProps={props}
      body={
        <ScrollableContentBody className="thumbnails-layout-container">
          {props.elements.map(renderThumbnail)}
        </ScrollableContentBody>
      }
    />
  )
}

export default IconThumbnails
